import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-ad3',
  templateUrl: './ad3.component.html',
  styleUrls: ['./ad3.component.css']
})
export class Ad3Component implements OnInit {

  @Output() stepChangeEvent = new EventEmitter<string>();

  @Input() propertyType: string;

  @Input() listingFor: string;

  thirdAdForm: FormGroup = new FormGroup({ 
    title: new FormControl('', [Validators.required]),
    price: new FormControl(null, [Validators.required]),
    bigha: new FormControl(null),
    kattha: new FormControl(null),
    dhur: new FormControl(null),
    kanwa: new FormControl(null),
    totalArea: new FormControl('', [Validators.required]),
    ropani: new FormControl(null),
    aana: new FormControl(null),
    paisa: new FormControl(null),
    daam: new FormControl(null),
    houseArea: new FormControl(null),
    floor: new FormControl(null),
    details: new FormControl(''),
    parking: new FormControl(''),
    waterSupply: new FormControl(''),
    electricity: new FormControl(''),
    telecommunication: new FormControl(''),
    gasSupply: new FormControl(''),
    otherFacilities: new FormControl('')
  })

  updateTotalArea() {
    const b = this.thirdAdForm.get('bigha').value;
    const k = this.thirdAdForm.get('kattha').value;
    const d = this.thirdAdForm.get('dhur').value;
    const kw = this.thirdAdForm.get('kanwa').value;
    if ((b !== null && b !== '') || (k !== null && k !== '') || (d !== null && d !== '') || (kw !== null && kw !== '')) {
      const bigha = b !== null && b !== '' ? b : 0;
      const kattha = k !== null && k !== '' ? k : 0;
      const dhur = d !== null && d !== '' ? d : 0;
      const kanwa = kw !== null && kw !== '' ? kw : 0;
      this.thirdAdForm.get('totalArea').setValue(`${bigha}-${kattha}-${dhur}-${kanwa}`);
    } else {
      this.thirdAdForm.get('totalArea').setValue('');
    }
  }

  updateHouseArea() {
    const r = this.thirdAdForm.get('ropani').value;
    const a = this.thirdAdForm.get('aana').value;
    const p = this.thirdAdForm.get('paisa').value;
    const dm = this.thirdAdForm.get('daam').value;
    if ((r !== null && r !== '') || (a !== null && a !== '') || (p !== null && p !== '') || (dm !== null && dm !== '')) {
      const ropani = r !== null && r !== '' ? r : 0;
      const aana = a !== null && a !== '' ? a : 0;
      const paisa = p !== null && p !== '' ? p : 0;
      const daam = dm !== null && dm !== '' ? dm : 0;
      this.thirdAdForm.get('houseArea').setValue(`${ropani}-${aana}-${paisa}-${daam}`);
    } else {
      this.thirdAdForm.get('houseArea').setValue(null);
    }
  }

  otherFacilities: FormArray

  otherFacility: FormGroup

  facebookInformationGroup: FormGroup

  facebookInformationGroupList: FormArray

  remainingLength: number

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Describe your property here.',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['fontSize']
    ]
  };

  constructor(private formBuilder: FormBuilder ) { }

  ngOnInit(): void {
    this.otherFacility = new FormGroup({
      forms: this.formBuilder.array([])
    })
    this.createFormArray()
  }

  createFormArray(){
    this.otherFacilities = this.otherFacility.get('forms') as FormArray
    this.otherFacilities.push(this.createGroup())
  }

  createGroup(): FormGroup {
    return this.formBuilder.group({
      title: new FormControl('', [Validators.required]),
      details: new FormControl('', [Validators.required])
    })
  }

  addOtherFacility(){
    this.createFormArray()
  }

  submitOtherFacilities(){
    let forms = this.otherFacility.get('forms')['controls']
    let facilities = []
    if(forms.length > 0){
      for(let form of forms){
        if(form.valid){
          let facilityInfo = form.value
          facilities.push(facilityInfo)
        }
      }
    }
    this.thirdAdForm['controls']['otherFacilities'].setValue(JSON.stringify(facilities))
  }

  removeOtherFacilityAt(index){
    this.otherFacilities.removeAt(index)
  }

  next(){
    this.updateTotalArea();
    this.updateHouseArea();
    this.submitOtherFacilities();
    this.stepChangeEvent.emit('step-4');
  }

  previous(){
    this.stepChangeEvent.emit('step-2')
  }

}
